import { LanderContainer } from '@/components/shared/LanderContainer';
import { AuthProvider } from '@/contexts/AuthContext';
import { LaunchDarklyProvider } from '@/contexts/LaunchDarklyContext';
import { QueryClientProvider } from '@/contexts/QueryClientContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { KPI } from '@/hooks/useCampaigns';
import { AccountSettingsLayout } from '@/layouts/AccountSettingsLayout';
import { AuthLayout } from '@/layouts/AuthLayout';
import { ReportsLayout } from '@/layouts/ReportsLayout';
import { TeamSettingsLayout } from '@/layouts/TeamSettingsLayout';
import { AccountBillingPage } from '@/pages/AccountBillingPage';
import { AccountConnectionsPage } from '@/pages/AccountConnectionsPage';
import { AccountProfilePage } from '@/pages/AccountProfilePage';
import { AuthPage } from '@/pages/AuthPage';
import { ContentCalendarPage } from '@/pages/ContentCalendarPage';
import { Error500Page } from '@/pages/Error500Page';
import { ErrorPage } from '@/pages/ErrorPage';
import { HomePage } from '@/pages/HomePage';
import { PrivacyPage } from '@/pages/PrivacyPage';
import { ReportsPage } from '@/pages/ReportsPage';
import { TeamMembersPage } from '@/pages/TeamMembersPage';
import { TeamSettingsPage } from '@/pages/TeamSettingsPage';
import { TermsPage } from '@/pages/TermsPage';
import { ProtectedRoute } from '@/routes/ProtectedRoute';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/auth" element={<AuthPage />} />
      <Route element={<LanderContainer />}>
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Route>

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/calendar" element={<ContentCalendarPage />} />

          {/* Reports Routes - Order matters! */}
          <Route element={<ReportsLayout />}>
            <Route path="/reports" element={<ReportsPage />} />
            <Route
              path="/reports/:id"
              element={<Navigate to={`${KPI.AWARENESS}`} replace />}
            />
            <Route path="/reports/:id/:kpi" element={<ReportsPage />} />
          </Route>

          {/* Team Settings Routes */}
          <Route path="/team" element={<TeamSettingsLayout />}>
            <Route path="settings" element={<TeamSettingsPage />} />
            <Route path="members" element={<TeamMembersPage />} />
            <Route path="connections" element={<AccountConnectionsPage />} />
          </Route>

          {/* Account Settings Routes */}
          <Route path="/account" element={<AccountSettingsLayout />}>
            <Route path="profile" element={<AccountProfilePage />} />
            <Route path="billing" element={<AccountBillingPage />} />
          </Route>
        </Route>
      </Route>

      {/* Error routes */}
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/500" element={<Error500Page />} />

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export const App = () => {
  return (
    <BrowserRouter>
      <QueryClientProvider>
        <ThemeProvider
          props={{
            attribute: 'class',
            defaultTheme: 'light',
            enableSystem: false,
          }}>
          <AuthProvider>
            <LaunchDarklyProvider>
              <AppRoutes />
            </LaunchDarklyProvider>
          </AuthProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
};
